module.exports = __webpack_public_path__ + "static/Forager0-e7f375ab4ffa878fb48d2ed1d62b936c.webp";